// extracted by mini-css-extract-plugin
export default {"address":"AddressesView_address__Undfa"};